import React from "react";
// import Navigation from "./Navigation";
import Site from "./Tab/Site";
// import Partners from "./Tab/Partners";
import "./index.scss";

const Tools = () => {
  return (
    <div className="GCL-H-T">
      {/* <Navigation /> */}
      <Site />
      {/* <Partners /> */}
    </div>
  );
};

export default Tools;
